import React from 'react';
import LexiLiteAIHeader from '../Header/LexiLiteAIHeader/LexiLiteAIHeader';
// import './LexiLiteAI.css';

const LexiLiteAI = () => (
  <section className="product-display-container" id="lexilite">
    <LexiLiteAIHeader />
    <div className="product-detail-grid">
      <div className="detail-narrative">
        <h3>Local Audio Pipeline Optimization</h3>
        <p className="p__opensans">
          LexiLiteAI provides real-time, low-latency pronunciation assessment and grammar feedback vectors.
          By executing model inference directly on Apple Silicon Neural Engines (A14-A19/M-Series chips) via compiled CoreML graphs,
          the platform maintains total user voice privacy with zero cloud processing overhead.
        </p>
        <a href="https://apps.apple.com/in/app/lexilite/id6648782528" target="_blank" rel="noreferrer" className="appstore-action-link">
          Deploy via iOS App Store ↗
        </a>
      </div>
      <div className="detail-specs-box">
        <h4>Telemetry Specifications</h4>
        <ul>
          <li>Engine: CoreML Local Inference Pipeline</li>
          <li>Features: Phoneme Token Alignment, Syntactic Grammar Analysis</li>
          <li>Hardware Vector: On-Device Neural Processing Unit (NPU)</li>
        </ul>
      </div>
    </div>
  </section>
);

export default LexiLiteAI;
